import { FC } from "react"
import { DefaultMoodIconSize } from "../../utils/constants"
import { MoodIconProps } from "../../utils/types"

const MoodHighestIcon: FC<MoodIconProps> = ({
  x,
  y,
  height = DefaultMoodIconSize,
  width = DefaultMoodIconSize,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      y={y}
      x={x}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 10C0 4.47715 4.47715 0 10 0C15.5204 0.00597071 19.994 4.47963 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM1.66687 9.99837C1.66687 14.6007 5.39783 18.3317 10.0002 18.3317C14.6005 18.3267 18.3285 14.5987 18.3335 9.99837C18.3335 5.396 14.6026 1.66504 10.0002 1.66504C5.39783 1.66504 1.66687 5.396 1.66687 9.99837ZM7.08333 9.58171C7.54357 9.58171 7.91667 9.20861 7.91667 8.74837V6.24837C7.91667 5.78814 7.54357 5.41504 7.08333 5.41504C6.6231 5.41504 6.25 5.78814 6.25 6.24837V8.74837C6.25 9.20861 6.6231 9.58171 7.08333 9.58171ZM13.7498 8.74837C13.7498 9.20861 13.3767 9.58171 12.9165 9.58171C12.4562 9.58171 12.0831 9.20861 12.0831 8.74837V6.24837C12.0831 5.78814 12.4562 5.41504 12.9165 5.41504C13.3767 5.41504 13.7498 5.78814 13.7498 6.24837V8.74837Z"
        fill="#424F80"
        fill-opacity="0.7"
      />
      <path
        d="M10 15.8317C12.0711 15.8317 13.75 13.9662 13.75 11.665H6.25C6.25 13.9662 7.92893 15.8317 10 15.8317Z"
        stroke="#424F80"
        stroke-opacity="0.7"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default MoodHighestIcon
